import React, { useState, useRef } from 'react';
import ReactCrop, { makeAspectCrop, convertToPixelCrop } from 'react-image-crop';
import { canvasPreview } from './canvasPreview';
import { useDebounceEffect } from './useDebounceEffect';

import 'react-image-crop/dist/ReactCrop.css';

import { get, post } from '../../utils/apiUtils';
function topLeftAspectCrop(mediaWidth, mediaHeight, aspect) {
  // Define the crop starting from the top-left corner
  const cropWidth = Math.min(mediaWidth, mediaHeight * aspect);
  const cropHeight = cropWidth / aspect;

  return {
    unit: 'px',
    x: 0, // Start from the top-left corner
    y: 0,
    width: cropWidth,
    height: cropHeight,
  };
}

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${BASE_URL}/api/v1/persistence/upload`;

const ImageCropper = ({ uploadedImage, onCropComplete, onFileUpload }) => {
  const [imgSrc, setImgSrc] = useState('');
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const hiddenAnchorRef = useRef(null);
  const blobUrlRef = useRef('');
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState(null);
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState(1); // Aspect ratio of 1 (square)

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setCrop(undefined); // Reset crop when a new file is selected
      const reader = new FileReader();
      reader.addEventListener('load', () => setImgSrc(reader.result?.toString() || ''));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onImageLoad = (e) => {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(topLeftAspectCrop(width, height, aspect)); // Use top-left crop logic
    }
  };

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate
        );
      }
    },
    100,
    [completedCrop, scale, rotate]
  );

  async function onDownloadCropClick() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;

    if (!image || !previewCanvas || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    // Create a Blob from the canvas
    previewCanvas.toBlob(
      async (blob) => {
        if (!blob) {
          console.error('Failed to create blob');
          return;
        }

        // Convert the Blob to a File object
        const croppedFile = new File([blob], 'cropped-image.png', { type: 'image/png' });

        // Upload the cropped file
        const fileName = await handleUpload(croppedFile);
        if (fileName) {
          // Emit the file name to the parent component
          if (onFileUpload) {
            onFileUpload(fileName);
          }
        }
      },
      'image/png',
      1 // Quality (1 = max quality)
    );
  }
  const handleUpload = async (croppedImage) => {
    if (croppedImage) {
      const formData = new FormData();
      formData.append('file', croppedImage);

      try {
        const response = await post(
          `${API_URL}/platform_user_profile/profile_url/` + new Date().getTime(),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        // Extract the file name from the response
        const fileName = response?.data?.url;

        return fileName; // Emit the file name
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
  };
  return (
    <div className="App">
      <div className="Crop-Controls">
        <input type="file" accept="image/*" onChange={onSelectFile} />
      </div>
      {!!imgSrc && (
        <div
          style={{
            maxHeight: '400px', // Set max height for the crop area
            overflow: 'hidden', // Prevent content from exceeding the container
            display: 'flex', // Center the image within the container
            justifyContent: 'center',
            alignItems: 'center',
            gap: "30px"
          }}
        >
          <ReactCrop
            src={imgSrc}
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={(c) => setCompletedCrop(c)}
            aspect={aspect}
          >
            <img
              ref={imgRef}
              alt="Crop me"
              src={imgSrc}
              style={{
                // transform: `scale(${scale}) rotate(${rotate}deg)`
                maxHeight: '400px', // Automatically scale the image to fit the parent
                maxWidth: '100%', // Ensure the image does not exceed the container width
                objectFit: 'contain', // Maintain aspect ratio
              }}
              onLoad={onImageLoad}
            />
          </ReactCrop>
          <div>

            {!!completedCrop && (
              <>
                <div>

                  <div>
                    <button onClick={onDownloadCropClick}>Download Crop</button>
                    <a
                      href="#hidden"
                      ref={hiddenAnchorRef}
                      download
                      style={{
                        position: 'absolute',
                        top: '-200vh',
                        visibility: 'hidden',
                      }}
                    >
                      Hidden download
                    </a>
                  </div>
                  <canvas
                    ref={previewCanvasRef}
                    style={{
                      border: '1px solid black',
                      objectFit: 'contain',
                      width: `${completedCrop.width}px`,
                      height: `${completedCrop.height}px`,
                    }}
                  />
                  {/* <canvas
              ref={previewCanvasRef}
              style={{
                border: '1px solid black',
                objectFit: 'contain',
                width: completedCrop.width,
                height: completedCrop.height,
              }}
            /> */}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageCropper;